import { Component, OnInit } from '@angular/core';
import { ReportService } from '../../service/report.service';
import { NotifierService } from 'angular-notifier';
import { RepoApiService } from '../../service/repo-api.service';
@Component({
  selector: 'app-move-all-file',
  templateUrl: './move-all-file.component.html',
  styleUrls: ['./move-all-file.component.scss']
})
export class MoveAllFileComponent implements OnInit {
  // public allStudies:any[] = [];
  // public allStudiesCopy:any[] = [];
  constructor(public reportService:ReportService,
    public notifier: NotifierService,
    public repoService:RepoApiService
  ) { }

  ngOnInit(): void {
    // this.getAllStudy();
  }

  closeMove(){
    this.reportService.selectedStudyIDForMove = "";
    this.reportService.isMoveAllFileOpen = false;
  }


  onSubmit(){
    // console.log("on submit ====> ",this.reportService.allSelectedFiles);
    let selectedFiles = this.reportService.getSelectedFilesId();
    if(selectedFiles.length == 0){
      this.notifier.notify('error', 'Please select files to move');
      return;
    }
    if(!this.reportService.selectedStudyIDForMove || this.reportService.selectedStudyIDForMove == ""){
      this.notifier.notify('error', 'Please select a study to move files to');
      return;
    }
    let body = {
      "study_id": this.reportService.selectedStudyIDForMove,
      "file_id": selectedFiles,
      "keep_original":true
    }
    // console.log("body ====> ",body);
    // this.reportService.moveAllFiles(body).subscribe((res:any) => {
    //   if(res['status'] == 1){
    //     this.reportService.isMoveAllFileOpen = false;
    //     this.reportService.allSelectedFiles = [];
    //     this.reportService.close();
    //     } 
    // });

    this.repoService.moveFile(body).subscribe(result =>{
                if(result['status'] == 1){
                  this.closeMove();
                  this.reportService.close();
                  this.reportService.allSelectedFiles = [];
                  this.reportService.notify.notify('success', 'Files moved successfully');
                  this.reportService.isLoading = false;
                } else if(result['status'] == 2){
                  this.closeMove();
                  this.reportService.close();
                  this.reportService.allSelectedFiles = [];
                  this.reportService.notify.notify('success', result['message']);
                  this.reportService.isLoading = false;
                } else {
                  this.reportService.isLoading = false;
                  this.notifier.notify("error","Something went wrong!")
                }
              })


  }

  onStudyChange(searchText:string){
    // console.log("on study change ====> ",searchText);
    if(searchText === ""){
      this.reportService.allStudies = JSON.parse(JSON.stringify(this.reportService.allStudiesCopy));
      return;
    }
    this.reportService.allStudies = this.reportService.allStudiesCopy.filter((study:any) => study.title.toLowerCase().includes(searchText.toLowerCase()));
    this.reportService.selectedStudyIDForMove
    let isStudySelected = this.reportService.allStudies.some((study:any) => study['uuid'] === this.reportService.selectedStudyIDForMove);
    if(!isStudySelected){
      this.reportService.selectedStudyIDForMove = "";
    }
  }
  selectStudy(){
    // console.log("select study ====> ",this.reportService.selectedStudyIDForMove);
  }

  addStudy(){
    // let selectedFiles = this.reportService.getSelectedFilesId();
    this.reportService.selectedStudyIDForMove = "";
    this.reportService.isMoveToNewStudy = true;
    this.reportService.isMoveAllFileOpen = false;
  }

  // getAllStudy(){
  //   let query = {no_pagination :true};
  //   this.reportService.getUploadData(query,'allstudy').subscribe((res:any)=>{
  //     this.allStudies = res.data;
  //     this.allStudiesCopy = JSON.parse(JSON.stringify(res.data));
  //   });

  // }
}
